import React, { useState } from "react";
import "./styles.css";
import axios from "axios";

import useAuth from "../../hooks/useAuth";

import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { Menu } from "antd";

const { SubMenu } = Menu;

const Navbar = () => {
  const [current, setCurrent] = useState();
  let navigate = useNavigate();
  const { auth } = useAuth();
  const { setAuth } = useAuth();

  const handleClick = (e) => {
    console.log("click ", e);
    setCurrent(e.key);
    navigate("/" + e.key);
  };

  const config = {
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const handleLogout = () => {
    // navigate("/login");

    axios
      .get("/api/logout", config)
      .then((res) => {
        navigate("/");
      })
      .then(() => {
        console.log("auth", auth);
        setAuth({});
      })
      .then(() => {
        console.log("auth despues", auth);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const handleLogin = () => {
    navigate("/login");
  };
  return (
    <div className="navbar-container">
      <div className="logo">Awesome Blossom</div>

      <div className="menu-items">
        <Menu
          style={{ borderBottom: "none" }}
          onClick={handleClick}
          selectedKeys={current}
          mode="horizontal"
          disabledOverflow="true"
        >
          {auth.username && (
            <>
              <Menu.Item key="home">Home</Menu.Item>
              <Menu.Item key="dashboard">Dashboard</Menu.Item>
              <SubMenu key="gastos" title="Gastos">
                <Menu.Item key="gastofab">Fabrica</Menu.Item>
                <Menu.Item key="gastonegocios">Negocios</Menu.Item>
              </SubMenu>

              <SubMenu key="billeteras-menu" title="Billeteras">
                <Menu.Item key="billeteras">Formulario</Menu.Item>
                <Menu.Item key="billeterasoverview">Overview</Menu.Item>
              </SubMenu>

              <SubMenu key="reports" title="Negocios">
                <Menu.ItemGroup title="Reportes">
                  <Menu.Item key="negociosgastos">Gastos</Menu.Item>
                  <Menu.Item key="reportday">Ventas por Dia</Menu.Item>
                  <Menu.Item key="reportshour">Ventas por Hora</Menu.Item>

                  <Menu.Item key="turnos">Turnos</Menu.Item>

                  <Menu.Item key="cierres">Cierres</Menu.Item>
                  <Menu.Item key="productsales">Productos Vendidos</Menu.Item>
                </Menu.ItemGroup>
              </SubMenu>
              <SubMenu key="fabrica" title="Fabrica">
                <Menu.ItemGroup title="Reportes">
                  <Menu.Item key="ventasygastos">Ventas y Gastos</Menu.Item>
                  <Menu.Item key="ticketsFab">Tickets</Menu.Item>

                  <Menu.Item key="productos">Productos Vendidos</Menu.Item>
                </Menu.ItemGroup>
              </SubMenu>

              <Menu.Item key="venta">Venta</Menu.Item>
              <SubMenu key="entities" title="Entities">
                <Menu.Item key="employees">Empleados</Menu.Item>
                <Menu.Item key="sucursales">Sucursales</Menu.Item>
                <Menu.Item key="usuarios">Usuarios</Menu.Item>
                <Menu.Item key="precios">Precios</Menu.Item>
                <Menu.Item key="preciosall">Precios Todo</Menu.Item>
              </SubMenu>

              <Menu.Item key="retiros">Retiros</Menu.Item>
              {/* <SubMenu key="entities" title="Entities">
                <Menu.Item key="employees">Empleados</Menu.Item>
                <Menu.Item key="sucursales">Sucursales</Menu.Item>
                <Menu.Item key="usuarios">Usuarios</Menu.Item>
                <Menu.Item key="precios">Precios</Menu.Item>
                <Menu.Item key="preciosall">Precios Todo</Menu.Item>
              </SubMenu> */}
            </>
          )}
        </Menu>
      </div>
      {auth.username ? (
        <div className="login-avatar">
          <Avatar
            style={{
              backgroundColor: "#87d068",
            }}
            icon={<UserOutlined />}
            key="login"
          />{" "}
          {` Welcome ${auth.username}!`}
          <div className="logout" onClick={handleLogout}>
            Logout
          </div>
        </div>
      ) : (
        <div className="login" onClick={handleLogin}>
          Login
        </div>
      )}
    </div>
  );
};

export default Navbar;
